import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThankyouSuccessHeadComponent } from './thankyou-success-head.component';
import { SharedModule } from '../../shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { ComponentLoader } from 'src/app/core/component-loader/component-loader.component';

@NgModule({
  declarations: [ThankyouSuccessHeadComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatIconModule,
    ComponentLoader
  ],
  exports: [ThankyouSuccessHeadComponent],
})
export class ThankyouSuccessHeadModule { }
